export enum TieOnTypes {
  Surface = 'Surface',
  Wellhead = 'Wellhead',
  Run = 'Run',
  Custom = 'Custom',
}